<template>
  <div>
    <v-menu
      ref="menu1"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="formattedDate"
          label="Insira a data"
          persistent-hint
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          dense
          outlined
        ></v-text-field>
      </template>
      <v-date-picker
        :key="date"
        v-model="date"
        @input="menu = false"
        @change="saveValueText"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  props: ["field", "model"],
  data() {
    return {
      date: this.normalizeToIsoDate(this.model),
      menu: false
    };
  },

  computed: {
    ...mapState("solicitation", ['solicitation_validate_values']),
    formattedDate() {
      return this.formatDate(this.date);
    }
  },

  watch: {
    model: {
      immediate: true,
      handler(value) {
        const normalized = this.normalizeToIsoDate(value);
        if (normalized) {
          this.date = normalized;
        }
      }
    }
  },

  mounted() {
    this.$emit('componentLoading', true);
    this.$emit('componentLoading', false);
  },

  methods: {
    ...mapMutations("forms", ["SET_FORM_EMAIL"]),
    ...mapActions("solicitation", ["updateSolicitationValidateValues"]),

    normalizeToIsoDate(value) {
      if (!value) return "";

      const str = String(value).trim();

      if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        return str;
      }

      if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
        return str.substring(0, 10);
      }

      const brDate = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (brDate) {
        return `${brDate[3]}-${brDate[2]}-${brDate[1]}`;
      }

      return "";
    },

    formatDate(date) {
      if (!date) return "";

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    saveValueText(selected) {
      this.updateSolicitationValidateValues({
        text: selected || "",
        value: selected || "",
        model: this.field.name
      });

      this.SET_FORM_EMAIL({});
      this.SET_FORM_EMAIL(this.solicitation_validate_values);
    }
  }
};
</script>
<style scoped></style>
